import React from 'react';
import service from "../../../service/service";
import DownloadReport from "../DownloadReport";

export default function UnusedSnapshotDownloadReport() {
    const apiCallFunction = service.monitoring().downloadSnapshot
    return <DownloadReport downloadFunction={apiCallFunction} title={'Download unused Snapshot report'}/>
}